import { getZReport } from '../../api/admin';
import invalidationManager from './InvalidationManager';

export interface ZReportData {
  id: string;
  report: {
    csv: string;
  };
}

export const { hook: useZReport, fetcher: zReportStore } = invalidationManager.createFetcher({
  queryKey: (companyId: string, reportId: string, registerKey?: string) => [
    'company',
    companyId,
    'z-report',
    reportId,
    ...(registerKey ? [registerKey] : []),
  ],
  fetchFunction: async (
    companyId: string,
    reportId: string,
    registerKey?: string,
  ): Promise<ZReportData | null> => {
    if (!companyId || !reportId) {
      return null;
    }
    return getZReport(companyId, reportId, registerKey);
  },
});
